import { mdiVote } from "@mdi/js";
import Icon from "@mdi/react";
import { useContext, useEffect, useReducer, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ElectionInput from "../../../../common/electionsInputField/ElectionInput";
import { MessageContext } from "../../../../common/message";
import { ThemeContext } from "../../../../common/theme/ThemeContext";
import { GET } from "../../../../utils/fetchUtil";
import CandidatesTable from "../CandidatesTable";
import { reducer } from "../ElectionsReducer";
import VotingFooterButtons from "../VotingFooterButtons";

const CreateNewElectionsDesktop = () => {
  const theme = useContext(ThemeContext);
  const [leftTableBorderVisible, setLeftTableBorderVisible] = useState(false);
  const [addCandidatTableVisible, setAddCandidatTableVisible] = useState(false);
  const [areDetailsVisible, setAreDetailsVisible] = useState(true);
  const [isDetailsFormValid, setIsDetailsFormValid] = useState(false);
  const [areInputFieldsDisabled, setAreInputFieldsDisabled] = useState(false);
  const [calendarDatumRaspisivanja, setCalendarDatumRaspisivanja] = useState();
  const [calendarDatumVrijemePocetkaGlasanja, setCalendarDatumVrijemePocetkaGlasanja] = useState();
  const [calendarDatumVrijemeZavrsetkaGlasanja, setCalendarDatumVrijemeZavrsetkaGlasanja] =
    useState();
  const location = useLocation();
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reducer, {
    id: null,
    dateCreated: null,
    description: "",
    numberOfChoices: 1,
    dateOfAnnouncement: null,
    dateOfLocking: null,
    dateOfCancellation: null,
    dateTimeVotingStart: null,
    dateTimeVotingEnd: null,
    reasonForCancellation: null,
    cancellationFileUrl: null,
    cancellationFilePath: null,
    locationId: 0,
    statusId: null,
    electionTypeId: 0,
    electionType: null,
    location: null,
    status: null,
    candidates: [],
    cancellationFile: [],
    generatedStatus: null,
    documents: [],
  });
  const [electionTypes, setElectionTypes] = useState([]);
  const [electionLocations, setElectionLocations] = useState([]);

  // Dohvati podatke za dropdowne - vrste izbora i lokacije
  useEffect(() => {
    GET(
      "/elections/types",
      (response) => {
        setElectionTypes(response);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
    GET(
      "/elections/locations",
      (response) => {
        setElectionLocations(response);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, []);

  useEffect(() => {
    if (calendarDatumRaspisivanja) {
      if (!calendarDatumRaspisivanja.includes("1970-01-01T")) {
        dispatch({
          type: "update",
          payload: { dateOfAnnouncement: calendarDatumRaspisivanja },
        });
      } else {
        dispatch({
          type: "update",
          payload: { dateOfAnnouncement: null },
        });
      }
    }
  }, [calendarDatumRaspisivanja]);

  useEffect(() => {
    if (calendarDatumVrijemePocetkaGlasanja) {
      if (!calendarDatumVrijemePocetkaGlasanja.includes("1970-01-01T")) {
        //
        dispatch({
          type: "update",
          payload: { dateTimeVotingStart: calendarDatumVrijemePocetkaGlasanja },
        });
      } else {
        dispatch({
          type: "update",
          payload: { dateTimeVotingStart: null },
        });
      }
    }
  }, [calendarDatumVrijemePocetkaGlasanja]);

  useEffect(() => {
    if (calendarDatumVrijemeZavrsetkaGlasanja) {
      if (!calendarDatumVrijemeZavrsetkaGlasanja.includes("1970-01-01T")) {
        dispatch({
          type: "update",
          payload: { dateTimeVotingEnd: calendarDatumVrijemeZavrsetkaGlasanja },
        });
      } else {
        dispatch({
          type: "update",
          payload: { dateTimeVotingEnd: null },
        });
      }
    }
  }, [calendarDatumVrijemeZavrsetkaGlasanja]);

  // Preko location.state pune se podaci (Kliknut je widget)
  useEffect(() => {
    if (location?.state) {
      setAddCandidatTableVisible(true);
      if (location.state.electionGeneratedStatus != "1") {
        setAreInputFieldsDisabled(true);
      }
      GET(
        "/election/" + location.state.id,
        (response) => {
          dispatch({ type: "init", payload: { ...response } });
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );

      // Dohvacanje kandidata prema Election ID-u
      GET(
        "/candidates?electionId=" + location.state.id,
        (response) => {
          response.forEach((candidate) => {
            dispatch({ type: "addCandidate", payload: candidate });
          });
        },
        (error) => {
          message.toggle({
            title: t("requests.reviewDocuments.action.save.error"),
            content: error,
            hideNo: true,
            yesLabel: t("modalMessage.okLabel"),
            onYes: () => {
              message.toggle({});
            },
          });
        }
      );
    }
  }, [location?.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let payloadData = {};
    payloadData[name] = value;
    if (name === "numberOfChoices") {
      if (value < 0 || value > 30) {
        payloadData = {
          numberOfChoices: state.numberOfChoices,
        };
      }
      if (value === "") {
        payloadData = {
          numberOfChoices: null,
        };
      }
    }
    dispatch({ type: "update", payload: payloadData });
  };

  useEffect(() => {
    if (addCandidatTableVisible) {
      setLeftTableBorderVisible(true);
    }
  }, [addCandidatTableVisible]);

  const handleIconVotesClick = () => {
    setAreDetailsVisible(!areDetailsVisible);
  };

  return (
    <>
      <div className="is-flex is-align-items-center is-justify-content-center is-size-4 mt-6">
        <h1 className="m-0 mr-5">Elektronički</h1>
        <Icon path={mdiVote} size={2.7} className={`has-text-${theme.iconColor}`} />
        <h1 className="m-0 ml-5"> izbori</h1>
      </div>
      {addCandidatTableVisible ? (
        <div className="columns is-mobile mt-6">
          <div className="column is-three-fifths is-offset-one-fifth is-flex is-justify-content-center">
            <h3 className="has-text-centered is-italic">
              {/* Naslov iznad forme za izbore */}
              {state?.electionType?.typeName}&nbsp;
            </h3>
            <h3
              style={{ color: "#7d658e" }}
              className={`has-text-${theme.iconColor} has-text-centered is-italic m-0`}
            >
              {/* Status izbora na kraju naslova */}
              {state.generatedStatus?.status ? `- ${state.generatedStatus.status}` : ""}
            </h3>
          </div>
        </div>
      ) : null}
      <div className="columns is-mobile mt-4 is-centered ">
        <div className="column is-10 is-centered ">
          {/* Header - icon and title */}
          <div className="columns mb-4">
            <div className="column is-1">
              {addCandidatTableVisible ? (
                <div
                  onClick={handleIconVotesClick}
                  className="is-flex is-align-items-center is-justify-content-center"
                >
                  <Icon
                    path={mdiVote}
                    size={2}
                    className={`has-text-${theme.iconColor} icon-votes`}
                  />
                </div>
              ) : (
                <div className="is-flex is-align-items-center is-justify-content-center">
                  <Icon path={mdiVote} size={2} className={`has-text-${theme.iconColor}`} />
                </div>
              )}
            </div>
            <div className="column is-flex is-align-items-center">
              <h3 className="is-size-3 m-0">Izbori</h3>
            </div>
          </div>
          {/* Content */}
          {/* Tablica s podacima */}
          <form
            onSubmit={() => {
              console.log("Aktivirano");
            }}
          >
            <div style={{ display: `${areDetailsVisible ? "flex" : "none"}` }} className="columns">
              <div className="column is-1 vote-table-left-line">
                <div className="is-flex is-align-items-center is-justify-content-center">
                  {/* Linija ispod ikone */}
                  <div
                    style={
                      leftTableBorderVisible
                        ? { width: "49%", height: "100px", borderRight: "1px solid  #d5d3d6" }
                        : { width: "49%", height: "100px" }
                    }
                  ></div>
                  <div style={{ width: "50%", height: "100px" }}></div>
                </div>
              </div>

              {/* vote-table-info  */}
              <div
                style={{ height: "100px" }}
                className="column is-flex is-align-items-center is-justify-content-space-between"
              >
                <div
                  // custom width jer vrsta izbora mora biti duga do kraja voting start inputa
                  style={{ width: "63.2%", flex: "none" }}
                  className="column is-flex is-align-items-center is-justify-content-space-between pl-0"
                >
                  <ElectionInput
                    isRequired={true}
                    placeholder="Vrsta izbora"
                    onChange={handleInputChange}
                    name={"electionTypeId"}
                    value={state.electionType?.id ? state.electionType.id : 0}
                    disabled={areInputFieldsDisabled}
                    isDropdown={true}
                    dropdownOptions={electionTypes}
                    dropdownType={"vrstaIzbora"}
                    dispatch={dispatch}
                  />
                </div>
                <div className="column is-one-quarter pr-0">
                  <ElectionInput
                    isRequired={false}
                    placeholder="Broj mogućih odabira"
                    onChange={handleInputChange}
                    name={"numberOfChoices"}
                    value={state.numberOfChoices}
                    disabled={areInputFieldsDisabled}
                  />
                </div>
              </div>
            </div>
            {/* 2. red */}
            <div style={{ display: `${areDetailsVisible ? "flex" : "none"}` }} className="columns">
              <div className="column is-1 vote-table-left-line">
                <div className="is-flex is-align-items-center is-justify-content-center ">
                  <div
                    style={
                      leftTableBorderVisible
                        ? { width: "49%", height: "100px", borderRight: "1px solid  #d5d3d6" }
                        : { width: "49%", height: "100px" }
                    }
                  ></div>
                  <div style={{ width: "50%", height: "100px" }}></div>
                </div>
              </div>
              <div className="vote-table-info column is-flex is-align-items-center is-justify-content-space-between">
                <div className="column is-full">
                  <ElectionInput
                    isRequired={false}
                    placeholder="Opis izbora"
                    isNumber={false}
                    onChange={handleInputChange}
                    name={"description"}
                    value={state.description}
                    disabled={areInputFieldsDisabled}
                  />
                </div>
              </div>
            </div>
            {/* 3. red */}
            <div style={{ display: `${areDetailsVisible ? "flex" : "none"}` }} className="columns">
              <div className="column is-1 vote-table-left-line">
                <div className="is-flex is-align-items-center is-justify-content-center ">
                  <div
                    style={
                      leftTableBorderVisible
                        ? { width: "49%", height: "100px", borderRight: "1px solid  #d5d3d6" }
                        : { width: "49%", height: "100px" }
                    }
                  ></div>
                  <div style={{ width: "50%", height: "100px" }}></div>
                </div>
              </div>
              <div
                style={{ maxHeight: "100px" }} // Limited at 100px so right line (h. also 100px) doesnt fall apart
                className="vote-table-info column is-flex is-align-items-center is-justify-content-space-between"
              >
                <div className="column is-3">
                  <ElectionInput
                    isRequired={true}
                    placeholder="Datum raspisivanja"
                    isNumber={false}
                    isDate={true}
                    onChange={handleInputChange}
                    name={"dateOfAnnouncement"}
                    value={state.dateOfAnnouncement}
                    disabled={areInputFieldsDisabled}
                    id={"#calendarDatumRaspisivanja"}
                    calendar={state.dateOfAnnouncement}
                    setCalendar={setCalendarDatumRaspisivanja}
                  />
                </div>

                <div className="column is-3">
                  <ElectionInput
                    isRequired={false}
                    placeholder="Početak glasovanja"
                    isNumber={false}
                    isDateTime={true}
                    onChange={handleInputChange}
                    name={"dateTimeVotingStart"}
                    value={state.dateTimeVotingStart}
                    disabled={areInputFieldsDisabled}
                    id={"#calendarDatumVrijemePocetkaGlasanja"}
                    calendar={state.dateTimeVotingStart}
                    setCalendar={setCalendarDatumVrijemePocetkaGlasanja}
                  />
                </div>

                <div className="column is-3">
                  <ElectionInput
                    isRequired={false}
                    placeholder="Završetak glasovanja"
                    isNumber={false}
                    isDateTime={true}
                    onChange={handleInputChange}
                    name={"dateTimeVotingEnd"}
                    value={state.dateTimeVotingEnd}
                    disabled={areInputFieldsDisabled}
                    id={"#calendarDatumVrijemeZavrsetkaGlasanja"}
                    calendar={state.dateTimeVotingEnd}
                    setCalendar={setCalendarDatumVrijemeZavrsetkaGlasanja}
                  />
                </div>
              </div>
            </div>
            {/* 4. red */}
            <div style={{ display: `${areDetailsVisible ? "flex" : "none"}` }} className="columns">
              <div className="column is-1 vote-table-left-line">
                <div className="is-flex is-align-items-center is-justify-content-center ">
                  <div
                    style={
                      leftTableBorderVisible
                        ? { width: "49%", height: "100px", borderRight: "1px solid  #d5d3d6" }
                        : { width: "49%", height: "100px" }
                    }
                  ></div>
                  <div style={{ width: "50%", height: "100px" }}></div>
                </div>
              </div>
              <div
                style={{ height: "100px" }}
                className="vote-table-info column is-flex is-align-items-center is-justify-content-space-between"
              >
                <div className="column is-full">
                  <ElectionInput
                    isRequired={true}
                    placeholder="Lokacija izbora"
                    isNumber={false}
                    onChange={handleInputChange}
                    name={"locationId"}
                    value={state.location?.id ? state.location.id : 0}
                    disabled={areInputFieldsDisabled}
                    isDropdown={true}
                    dropdownType={"lokacija"}
                    dropdownOptions={electionLocations}
                    dispatch={dispatch}
                  />
                </div>
              </div>
            </div>
            {/* 5. red - razlog otkazivanja (vidljiv ako postoji r. otkazivanja)*/}
            {state.reasonForCancellation ? (
              <div
                style={{ display: `${areDetailsVisible ? "flex" : "none"}` }}
                className="columns"
              >
                <div className="column is-1 vote-table-left-line">
                  <div className="is-flex is-align-items-center is-justify-content-center ">
                    <div
                      style={
                        leftTableBorderVisible
                          ? { width: "49%", height: "100px", borderRight: "1px solid  #d5d3d6" }
                          : { width: "49%", height: "100px" }
                      }
                    ></div>
                    <div style={{ width: "50%", height: "100px" }}></div>
                  </div>
                </div>
                <div
                  style={{ height: "100px" }}
                  className="vote-table-info column is-flex is-align-items-center is-justify-content-space-between"
                >
                  <div className="column is-full">
                    <ElectionInput
                      isRequired={false}
                      placeholder="Razlog otkazivanja"
                      isNumber={false}
                      onChange={handleInputChange}
                      name={"reasonForCancellation"}
                      value={state.reasonForCancellation}
                      disabled={areInputFieldsDisabled}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </form>
          {areDetailsVisible ? null : (
            <div className="columns">
              <div className="column is-1 vote-table-left-line">
                <div className="is-flex is-align-items-center is-justify-content-center ">
                  <div
                    style={
                      leftTableBorderVisible
                        ? { width: "49%", height: "50px", borderRight: "1px solid  #d5d3d6" }
                        : { width: "49%", height: "50px" }
                    }
                  ></div>
                  <div style={{ width: "50%", height: "50px" }}></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {addCandidatTableVisible ? (
        <CandidatesTable
          areInputFieldsDisabled={areInputFieldsDisabled}
          dispatch={dispatch}
          electionState={state}
        />
      ) : null}
      <div className="mb-5">
        <VotingFooterButtons
          electionState={state}
          electionTypes={electionTypes}
          setAddCandidatTableVisible={setAddCandidatTableVisible}
          addCandidatTableVisible={addCandidatTableVisible}
          isDetailsFormValid={isDetailsFormValid}
          setisDetailsFormValid={setIsDetailsFormValid}
          disabled={areInputFieldsDisabled}
          dispatch={dispatch}
        />
      </div>
    </>
  );
};

export default CreateNewElectionsDesktop;
